import React from 'react'
import { GridComponent, Inject, Toolbar, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-react-grids'
import { useInstData } from 'tyan/public/hooks'

const Grid = props => {
	const { columns, data, searchable } = props
	const { me } = useInstData(props)

	const toolbar = []
	searchable && toolbar.push('Search')

	return <GridComponent ref={ref => ref && (me.gridObj = ref)} dataSource={data} height='100%'
		columns={columns} toolbar={toolbar}
	// {[
	// 	{ field: 'No', headerText: '编号', width: '120', textAlign: 'Right' },
	// 	{ field: 'Subject', headerText: '主题', minWidth: '150' },
	// 	{ field: 'Publisher', headerText: '发布人', width: '130', textAlign: 'Right' },
	// 	{ field: 'PublishDate', headerText: '日期', width: '120', type: 'Date', format: 'yyyy/MM/dd' }
	// ]}
	>
		<Inject services={[Toolbar]} />
		{/* <ColumnsDirective>
			<ColumnDirective field='No' headerText='编号' width='120' textAlign='Right'></ColumnDirective>
			<ColumnDirective field='Subject' headerText='主题' minWidth='150'></ColumnDirective>
			<ColumnDirective field='Publisher' headerText='发布人' width='130' textAlign='Right' />
			<ColumnDirective field='PublishDate' headerText='日期' width='120' type='Date' format='yyyy/MM/dd' />
		</ColumnsDirective> */}
	</GridComponent>
}

export default Grid